import styled from 'styled-components';
import { Card, Tag } from 'antd';

export const Container = styled.div`
  width: 100%;
`;

export const PageHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  flex-wrap: wrap;
  gap: 16px;

  h2 {
    font-size: 22px;
    font-family: 'Roboto', sans-serif;
    font-weight: bold;
    color: var(--gray-200);
    margin-bottom: 0;
  }
`;

export const FilterContainer = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
`;

export const SummaryCard = styled(Card)`
  margin-bottom: 24px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);

  .ant-card-body {
    padding: 20px 24px;
  }
`;

export const SummaryContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;

  @media (max-width: 576px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const SummaryItem = styled.div`
  text-align: center;

  @media (max-width: 576px) {
    text-align: left;
  }
`;

export const SummaryLabel = styled.div`
  font-size: 12px;
  color: #8c8c8c;
  margin-bottom: 4px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const SummaryValue = styled.div<{ $color?: string }>`
  font-size: 24px;
  font-weight: 700;
  color: ${({ $color }) => $color || '#262626'};
`;

export const NoticeContainer = styled.div`
  display: flex;
  gap: 12px;
  margin-bottom: 24px;
  padding: 16px 20px;
  background-color: #fffbe6;
  border: 1px solid #ffe58f;
  border-radius: 12px;
`;

export const NoticeIcon = styled.div`
  flex-shrink: 0;
  margin-top: 2px;
  font-size: 20px;
  line-height: 1;
  color: #d48806;
`;

export const NoticeContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const NoticeText = styled.p`
  margin: 0;
  font-size: 13px;
  line-height: 1.6;
  color: #614700;
`;

export const DividasList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const DividaCard = styled(Card)<{ $scopeColor: string }>`
  border-radius: 12px;
  border-left: 4px solid ${({ $scopeColor }) => $scopeColor};
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  transition: all 0.2s ease;

  &:hover {
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
    transform: translateY(-2px);
  }

  .ant-card-body {
    padding: 20px 24px;
  }
`;

export const DividaCardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 16px;
  flex-wrap: wrap;
  gap: 12px;
`;

export const DividaCardTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const ScopeTag = styled(Tag)<{ $bgColor: string }>`
  background-color: ${({ $bgColor }) => $bgColor};
  color: #fff;
  border: none;
  font-weight: 600;
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 12px;
`;

export const DividaDate = styled.span`
  color: #8c8c8c;
  font-size: 14px;
`;

export const DividaValue = styled.div`
  font-size: 20px;
  font-weight: 700;
  color: #cf1322;
`;

export const DividaCardBody = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  flex-wrap: wrap;
  gap: 16px;
`;

export const DividaInfo = styled.div`
  flex: 1;
`;

export const NotesText = styled.p`
  color: #595959;
  font-size: 14px;
  margin: 0;
  line-height: 1.5;
`;

export const DividaActions = styled.div`
  display: flex;
  gap: 8px;
`;

export const EmptyContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  text-align: center;
`;

export const EmptyIcon = styled.div`
  font-size: 64px;
  color: #52c41a;
  margin-bottom: 16px;
`;

export const EmptyTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: #262626;
  margin-bottom: 8px;
`;

export const EmptyDescription = styled.p`
  font-size: 14px;
  color: #8c8c8c;
  margin: 0;
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: 60px 0;
`;

export const WhatsappContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 32px;
  padding: 24px;
  background-color: #f0f9ff;
  border: 1px solid #bae6fd;
  border-radius: 12px;
`;

export const WhatsappText = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #1e40af;
  margin-bottom: 12px;
  text-align: center;
`;

export const WhatsappLink = styled.a.attrs({
  target: '_blank',
})`
  background-color: #25d366;
  color: white !important;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(37, 211, 102, 0.2);

  &:hover {
    background-color: #20c057;
    transform: translateY(-2px);
    box-shadow: 0 4px 16px rgba(37, 211, 102, 0.3);
    color: white !important;
  }
`;

export const WhatsappImage = styled.img.attrs({
  src: './images/whatsapp.png',
  alt: 'Whatsapp icon',
})`
  width: 24px;
  height: 24px;
`;
